import { trans } from '@spotahome/soyuz/client';

import { showToast } from '../Toast';
import MapIcon from '../icons/MapIcon';

const renderIcon = () => <MapIcon />;
const renderTitle = () => trans('autocompleter.toast.feedback.title');
const renderContent = () => trans('autocompleter.toast.feedback.subtitle');

const CLOSE_AFTER_MS = 8000;

export const showFeedbackToast = () => {
  showToast(
    { renderIcon, renderTitle, renderContent },
    { autoClose: CLOSE_AFTER_MS }
  );
};
